import { render, staticRenderFns } from "./BenefitsForm.vue?vue&type=template&id=50b5266a"
import script from "./BenefitsForm.vue?vue&type=script&lang=js"
export * from "./BenefitsForm.vue?vue&type=script&lang=js"
import style0 from "./BenefitsForm.vue?vue&type=style&index=0&id=50b5266a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports